import { useState } from 'react';
import JoinModal from './JoinModal';
import './JoinCard.css';

const JoinCard = ({ style }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [isJoinModalOpen, setIsJoinModalOpen] = useState(false);

    return (
        <>
            <div
                className={`join-card ${isHovered ? 'join-card--hovered' : ''}`}
                onClick={() => setIsJoinModalOpen(true)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                style={style}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        setIsJoinModalOpen(true);
                    }
                }}
            >
                {/* Primary State */}
                <div className="join-card__primary">
                    <div className="join-card__silhouette-container">
                        <SilhouetteAvatar />
                    </div>
                    <div className="join-card__overlay">
                        <h3 className="join-card__name">Become an Expert</h3>
                        <p className="join-card__accolades">Join the Movement</p>
                    </div>
                </div>

                {/* Hover State */}
                <div className="join-card__secondary">
                    <div className="join-card__silhouette-container join-card__silhouette-container--hover">
                        <SilhouetteAvatar />
                    </div>
                    <div className="join-card__hover-content">
                        <h3 className="join-card__name join-card__name--hover">
                            Join Newro Connect
                        </h3>
                        <p className="join-card__bio">
                            Share your expertise, connect with clients, and grow your practice alongside fellow movement professionals.
                        </p>
                        <div className="join-card__skills">
                            <span className="join-card__skill-tag">Build Community</span>
                            <span className="join-card__skill-tag">Grow Practice</span>
                            <span className="join-card__skill-tag">Connect</span>
                        </div>
                        <p className="join-card__connection-reason">
                            Be part of the Newro Connect community
                        </p>
                    </div>
                </div>
            </div>

            <JoinModal
                isOpen={isJoinModalOpen}
                onClose={() => setIsJoinModalOpen(false)}
            />
        </>
    );
};

export default JoinCard;

const SilhouetteAvatar = () => (
    <svg viewBox="0 0 462.88 315.08">
        <g transform="translate(115.72 78.77) scale(0.5)">
            <path fill='#4f6f52' d="M416.93,46.14C387.3,16.39,347.9,0,305.99,0c-26.46,0-51.92,6.53-74.55,18.84C208.81,6.53,183.35,0,156.9,0c-41.91,0-81.31,16.39-110.94,46.14C16.32,75.9,0,115.46,0,157.54s16.32,81.64,45.95,111.4c29.64,29.75,69.03,46.14,110.94,46.14,26.46,0,51.91-6.53,74.55-18.84,22.63,12.31,48.09,18.84,74.55,18.84,41.9,0,81.31-16.39,110.94-46.14,29.63-29.76,45.95-69.32,45.95-111.4s-16.32-81.64-45.95-111.4ZM238.22,131.04l45.95-35.12c4.2,8.72,7.55,17.93,9.91,27.52l-55.86,42.7v-35.11ZM238.22,115.46V41.57c16.15,11.45,29.81,26.21,40,43.3l-40,30.58ZM156.9,299.42c-77.91,0-141.3-63.65-141.3-141.88S78.98,15.66,156.9,15.66c21.01,0,40.96,4.63,58.9,12.93-7.33,5.19-14.28,11.05-20.75,17.55-29.63,29.76-45.95,69.32-45.95,111.4s16.32,81.64,45.95,111.4c6.47,6.5,13.42,12.36,20.75,17.55-17.94,8.3-37.89,12.93-58.9,12.93ZM225.87,274.35c-28.61-19.84-49.61-50-57.61-85.08l57.61,44.04v41.04ZM225.87,217.71l-60.5-46.25c-.45-4.58-.68-9.23-.68-13.93,0-7.1.52-14.08,1.53-20.9l59.64,45.59v35.49ZM225.87,166.64l-56.96-43.54c8.45-33.92,29.09-63.04,56.96-82.37v125.91ZM238.22,181.74l58.5-44.72c.97,6.7,1.48,13.56,1.48,20.53,0,47.86-23.72,90.26-59.98,115.96v-91.77ZM305.99,299.42c-21.01,0-40.97-4.63-58.91-12.93,7.33-5.19,14.28-11.05,20.75-17.55,29.64-29.76,45.96-69.32,45.96-111.4s-16.32-81.64-45.96-111.4c-6.47-6.5-13.42-12.36-20.75-17.55,17.94-8.3,37.9-12.93,58.91-12.93,77.91,0,141.3,63.65,141.3,141.88s-63.38,141.88-141.3,141.88Z" />
        </g>
    </svg>
);
